import { PageButtonSchema } from '@/views/sports/components/PageButton/styles/PageButton.styles';

export const pageButtonStyles: PageButtonSchema = {
  button: {
    variant: 'outline',
    fontSize: '2xs',
    height: 'auto',
    borderRadius: 'base',
    textShadow: '0px 1px 2px rgba(0, 0, 0, 0.40)',
    boxShadow:
      '0px 2px 10px 0px rgba(0, 0, 0, 0.40), 0px 1px 0px 0px rgba(255, 255, 255, 0.45) inset, 0px 0px 0px 4px rgba(0, 0, 0, 0.10) inset',
    px: '3',
    py: '1',
    _hover: {
      '&&': {
        color: 'beta.700',
      },
      bg: 'white',
      borderColor: 'white',
      textShadow: 'none',
      boxShadow: 'none',
      _after: { opacity: '0' },
    },
    sx: { '&:active, &[data-active:"true"]': {} },
  },
};
